// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"444099dd","718":"fb748ab7"}[chunkId] + ".chunk.js";
};